import React, { useState } from "react";
import { submitVolunteer } from "../../utils/api/volunteerApi.js";
import { useLanguage } from "../../context/LanguageContext.jsx";

const INTERESTS = {
  ne: [
    "शहरी योजना तथा भौतिक पूर्वाधार",
    "सुरक्षा तथा सार्वजनिक सुरक्षा",
    "खानेपानी तथा जल व्यवस्थापन",
    "फोहोर तथा प्रदूषण व्यवस्थापन",
    "वन, वातावरण तथा पर्यटन",
    "शिक्षा, अनुसन्धान तथा ज्ञान विकास",
    "शिल्प, सीप तथा उद्यमशीलता विकास",
    "स्वास्थ्य तथा जनस्वास्थ्य",
    "स्वस्थ जीवनशैली तथा उपभोक्ता हित संरक्षण",
    "खेलकुद तथा खेल प्रशिक्षण",
    "सूचना प्रविधि तथा स्मार्ट सिटी विकास",
    "मिडिया तथा सञ्चार",
    "व्यापार, उद्योग तथा आर्थिक विकास",
    "कृषि तथा सहकारी विकास",
    "विपद् व्यवस्थापन तथा जलवायु अनुकूलन",
    "कला, संस्कृति तथा पहिचान संरक्षण",
    "सुशासन, आर्थिक नीति तथा वित्तीय व्यवस्थापन",
    "सामाजिक सुरक्षा तथा समावेशी विकास",
    "महिला, बालबालिका तथा युवा विकास",
    "अन्तर्राष्ट्रिय सम्बन्ध तथा साझेदारी",
    "प्रशासन तथा संस्थागत व्यवस्थापन",
  ],
  en: [
    "Urban Planning & Physical Infrastructure",
    "Security & Public Safety",
    "Water Supply & Water Management",
    "Waste & Pollution Management",
    "Forest, Environment & Tourism",
    "Education, Research & Knowledge Development",
    "Craft, Skills & Entrepreneurship Development",
    "Health & Public Health",
    "Healthy Lifestyle & Consumer Rights Protection",
    "Sports & Athletic Training",
    "Information Technology & Smart City Development",
    "Media & Communication",
    "Business, Industry & Economic Development",
    "Agriculture & Cooperative Development",
    "Disaster Management & Climate Adaptation",
    "Art, Culture & Identity Preservation",
    "Good Governance, Economic Policy & Financial Management",
    "Social Security & Inclusive Development",
    "Women, Children & Youth Development",
    "International Relations & Partnerships",
    "Administration & Institutional Management",
  ],
};

const GENDER_OPTIONS = {
  ne: [
    { value: "male", label: "पुरुष" },
    { value: "female", label: "महिला" },
    { value: "other", label: "अन्य" },
    { value: "prefer not to say", label: "भन्न नचाहने" },
  ],
  en: [
    { value: "male", label: "Male" },
    { value: "female", label: "Female" },
    { value: "other", label: "Other" },
    { value: "prefer not to say", label: "Prefer not to say" },
  ],
};

const CONTENT = {
  ne: {
    successTitle: "आवेदन पेश गरियो!",
    successDesc: "तपाईंको स्वयंसेवक आवेदन समीक्षाको लागि पेश भएको छ। हामी २-३ कार्य दिनभित्र तपाईंलाई सम्पर्क गर्नेछौं।",
    whatNext: "अब के हुन्छ?",
    steps: [
      "हाम्रा स्वयंसेवक संयोजकहरूद्वारा आवेदन समीक्षा (२-३ दिन)",
      "तपाईंको सीप र रुचिको आधारमा क्षेत्र मिलान",
      "तपाईंको स्वयंसेवक आईडी र पहिलो जिम्मेवारी सहितको इमेल",
    ],
    registerAnother: "अरू दर्ता गर्नुहोस्",
    eyebrow: "अभियानमा सामेल हुनुहोस्",
    titleHighlight: "स्वयंसेवक",
    titleSuffix: "बनुहोस्",
    headerDesc1: "नेपालको राष्ट्रिय विकास यात्रामा आफ्नो सीप योगदान गर्नुहोस्।",
    headerDesc2: "दर्ता गर्न ५ मिनेट भन्दा कम लाग्छ।",
    formTitle: "स्वयंसेवक दर्ता फारम",
    formSubtitle: "नेपालको स्वयंसेवक सञ्जालमा सामेल हुन तलको विवरण भर्नुहोस्",
    fullName: "पूरा नाम *",
    email: "इमेल ठेगाना *",
    phone: "फोन नम्बर *",
   
contributionType: "तपाईं कसरी योगदान दिन चाहनुहुन्छ? *",
    gender: "लिङ्ग",
    age: "उमेर *",
    profession: "पेशा *",
    address: "ठेगाना *",
    interestArea: "रुचिको क्षेत्र *",
    motivation: "तपाईं किन स्वयंसेवक बन्न चाहनुहुन्छ?",
    agreePrefix: "I agree to the",
    termsLabel: "Terms & Conditions",
    and: "and",
    privacyLabel: "Privacy Policy",
    agreeSuffix: "of the National Vision Platform.",
    submitting: "पेश गर्दैछ…",
    submit: "आवेदन पेश गर्नुहोस्",
    errorDefault: "आवेदन पेश गर्न असफल भयो। फेरि प्रयास गर्नुहोस्।",
  },
  en: {
    successTitle: "Application Submitted!",
    successDesc: "Your volunteer application has been submitted for review. We'll contact you within 2-3 working days.",
    whatNext: "What happens next?",
    steps: [
      "Application review by our volunteer coordinators (2-3 days)",
      "Sector matching based on your skills and interests",
      "Email with your volunteer ID and first assignment",
    ],
    registerAnother: "Register Another",
    eyebrow: "Join The Campaign",
    titleHighlight: "Become a",
    titleSuffix: "Volunteer",
    headerDesc1: "Contribute your skills to Nepal's national development journey.",
    headerDesc2: "Registration takes less than 5 minutes.",
    formTitle: "Volunteer Registration Form",
    formSubtitle: "Fill out the details below to join Nepal's volunteer network",
    fullName: "Full Name *",
    email: "Email Address *",
    phone: "Phone Number *",
    
contributionType: "How would you like to contribute? *",
    gender: "Gender",
    age: "Age *",
    profession: "Profession *",
    address: "Address *",
    interestArea: "Area of Interest *",
    motivation: "Why do you want to volunteer?",
    agreePrefix: "I agree to the",
    termsLabel: "Terms & Conditions",
    and: "and",
    privacyLabel: "Privacy Policy",
    agreeSuffix: "of the National Vision Platform.",
    submitting: "Submitting…",
    submit: "Submit Application",
    errorDefault: "Failed to submit application. Please try again.",
  },
};

const EMPTY = {
  name: "", email: "", phone: "", address: "",
  contributionType: "", gender: "", age: "", profession: "", province: "", district: "",
  interestArea: "", motivation: "", agreeTerms: false,
};

function Field({ label, col2, children }) {
  return (
    <div className={col2 ? "col-span-2" : ""}>
      <label className="block text-xs font-semibold text-gray-600 mb-1.5">{label}</label>
      {children}
    </div>
  );
}

function Input({ name, value, onChange, type = "text", placeholder }) {
  return (
    <input
      type={type}
      name={name}
      value={value}
      placeholder={placeholder}
      onChange={onChange}
      className="w-full px-3.5 py-2.5 rounded-xl border border-gray-200 text-sm text-gray-800 bg-white outline-none focus:border-green-800 focus:ring-2 focus:ring-green-800/10 transition-all"
    />
  );
}

function Select({ name, value, onChange, options, placeholder }) {
  return (
    <div className="relative">
      <select
        name={name}
        value={value}
        onChange={onChange}
        className="w-full px-3.5 py-2.5 rounded-xl border border-gray-200 text-sm bg-white outline-none focus:border-green-800 focus:ring-2 focus:ring-green-800/10 transition-all appearance-none cursor-pointer"
        style={{ color: value ? "#1f2937" : "#9ca3af" }}
      >
        <option value="">{placeholder}</option>
        {options.map((o) => {
          const optValue = typeof o === "string" ? o : o.value;
          const optLabel = typeof o === "string" ? o : o.label;
          return <option key={optValue} value={optValue}>{optLabel}</option>;
        })}
      </select>
      <span className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none text-gray-400 text-xs">▾</span>
    </div>
  );
}

const VolunteerForm = () => {
  const { language } = useLanguage();
  const t = CONTENT[language];
  const interests = INTERESTS[language];
  const genderOptions = GENDER_OPTIONS[language];

  const [formData, setFormData] = useState({ ...EMPTY });
  const [loading,  setLoading]  = useState(false);
  const [success,  setSuccess]  = useState(false);
  const [error,    setError]    = useState(null);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
      await submitVolunteer(formData);
      setSuccess(true);
      setFormData({ ...EMPTY });
    } catch (err) {
      setError(err?.response?.data?.message || t.errorDefault);
    } finally {
      setLoading(false);
    }
  };

  const canSubmit =
    formData.name && formData.email && formData.phone &&
    formData.age && formData.profession && formData.address &&
    formData.interestArea && formData.agreeTerms;

  if (success) return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-6">
      <div className="max-w-md w-full text-center">
        <div className="w-20 h-20 rounded-full flex items-center justify-center text-white text-4xl mx-auto mb-6" style={{ background: "rgb(21, 75, 43)" }}>✓</div>
        <h2 className="text-3xl font-extrabold text-gray-900 mb-3" style={{ fontFamily: "'Playfair Display',serif" }}>
          {t.successTitle}
        </h2>
        <p className="text-gray-500 text-sm leading-relaxed mb-8">
          {t.successDesc}
        </p>
        <div className="bg-white rounded-2xl border border-gray-100 p-6 text-left mb-6 shadow-sm">
          <p className="text-sm font-bold text-gray-800 mb-4">{t.whatNext}</p>
          {t.steps.map((step, i) => (
            <div key={i} className="flex gap-3 mb-3 last:mb-0">
              <div className="w-6 h-6 rounded-full flex items-center justify-center text-xs font-bold shrink-0 mt-0.5 text-white" style={{ background: "rgb(21, 75, 43)" }}>{i + 1}</div>
              <p className="text-sm text-gray-500 leading-relaxed">{step}</p>
            </div>
          ))}
        </div>
        <button
          onClick={() => setSuccess(false)}
          className="px-8 py-3 rounded-xl border-2 font-bold text-sm transition-colors"
          style={{ borderColor: "rgb(21,75,43)", color: "rgb(21,75,43)" }}
        >
          {t.registerAnother}
        </button>
      </div>
    </div>
  );

  return (
    <div className="min-h-screen bg-gray-50 font-sans">

      {/* Header */}
      <div className="pt-20 pb-14 px-6" style={{ background: "rgb(21, 75, 43)" }}>
        <div className="max-w-5xl mx-auto mt-6">
        
          <h1 className="text-white text-4xl lg:text-5xl font-bold leading-tight mb-3" style={{ fontFamily: "'Playfair Display',serif" }}>
            <span className="text-orange-400">{t.titleHighlight}</span> {t.titleSuffix}
          </h1>
          <p className="text-white/50 text-sm leading-relaxed max-w-sm">
            {t.headerDesc1}<br />
            {t.headerDesc2}
          </p>
        </div>
      </div>

      {/* Form */}
      <div className="max-w-3xl mx-auto px-6 py-12">
        <form onSubmit={handleSubmit}>
          <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-8 lg:p-10">

            {/* Form header */}
            <div className="flex items-center gap-4 mb-8 pb-6 border-b-2 border-green-100">
              <div className="w-11 h-11 rounded-xl flex items-center justify-center text-xl shrink-0" style={{ background: "rgb(21, 75, 43)" }}>🙋</div>
              <div>
                <h2 className="text-xl font-extrabold text-gray-900" style={{ fontFamily: "'Playfair Display',serif" }}>
                  {t.formTitle}
                </h2>
                <p className="text-xs text-gray-400 mt-0.5">{t.formSubtitle}</p>
              </div>
            </div>

            {error && (
              <div className="mb-6 px-4 py-3 rounded-xl bg-red-50 border border-red-200 text-red-700 text-sm">
                {error}
              </div>
            )}

            <div className="grid grid-cols-2 gap-4">
              <Field label={t.fullName} col2>
                <Input name="name" value={formData.name} onChange={handleChange} placeholder={t.namePlaceholder} />
              </Field>
              <Field label={t.email}>
                <Input name="email" type="email" value={formData.email} onChange={handleChange} placeholder={t.emailPlaceholder} />
              </Field>
              <Field label={t.phone}>
                <Input name="phone" value={formData.phone} onChange={handleChange} placeholder={t.phonePlaceholder} />
              </Field>
              <Field label={t.contributionType}>
  <Input
    name="contributionType"
    value={formData.contributionType}
    onChange={handleChange}
    placeholder={t.contributionPlaceholder}
  />
</Field>
              <Field label={t.gender}>
                <Select name="gender" value={formData.gender} onChange={handleChange}
                  options={genderOptions} placeholder={t.genderPlaceholder} />
              </Field>
              <Field label={t.age}>
                <Input name="age" type="number" value={formData.age} onChange={handleChange} placeholder={t.agePlaceholder} />
              </Field>
              <Field label={t.profession}>
                <Input name="profession" value={formData.profession} onChange={handleChange} placeholder={t.professionPlaceholder} />
              </Field>
              <Field label={t.address} col2>
                <Input name="address" value={formData.address} onChange={handleChange} placeholder={t.addressPlaceholder} />
              </Field>
              <Field label={t.interestArea} col2>
                <Select name="interestArea" value={formData.interestArea} onChange={handleChange}
                  options={interests} placeholder={t.interestPlaceholder} />
              </Field>
              <Field label={t.motivation} col2>
                <textarea
                  name="motivation"
                  value={formData.motivation}
                  onChange={handleChange}
                  rows={4}
                  placeholder={t.motivationPlaceholder}
                  className="w-full px-3.5 py-2.5 rounded-xl border border-gray-200 text-sm text-gray-800 outline-none focus:border-green-800 focus:ring-2 focus:ring-green-800/10 transition-all resize-y"
                />
              </Field>
            </div>

            <div className="mt-6">
              <label className="flex items-start gap-3 cursor-pointer">
                <input type="checkbox" name="agreeTerms" checked={formData.agreeTerms} onChange={handleChange} className="sr-only" />
                <div
                  className="w-5 h-5 rounded-md border-2 flex items-center justify-center shrink-0 mt-0.5 transition-all cursor-pointer"
                  style={{
                    background: formData.agreeTerms ? "rgb(21,75,43)" : "#fff",
                    borderColor: formData.agreeTerms ? "rgb(21,75,43)" : "#e5e7eb",
                  }}
                >
                  {formData.agreeTerms && <span className="text-white text-xs font-bold">✓</span>}
                </div>
                <span className="text-xs text-gray-500 leading-relaxed">
                  {t.agreePrefix}{" "}
                  <span className="underline cursor-pointer" style={{ color: "rgb(21,75,43)" }}>{t.termsLabel}</span>
                  {" "}{t.and}{" "}
                  <span className="underline cursor-pointer" style={{ color: "rgb(21,75,43)" }}>{t.privacyLabel}</span>
                  {" "}{t.agreeSuffix} <span className="text-red-500">*</span>
                </span>
              </label>
            </div>

            <button
              type="submit"
              disabled={!canSubmit || loading}
              className="mt-7 w-full py-3.5 rounded-xl text-white text-sm font-bold flex items-center justify-center gap-2 transition-all"
              style={{
                background: canSubmit && !loading ? "rgb(21, 75, 43)" : "#d1d5db",
                cursor: canSubmit && !loading ? "pointer" : "not-allowed",
                boxShadow: canSubmit && !loading ? "0 4px 14px rgba(21,75,43,0.3)" : "none",
              }}
            >
              {loading ? (
                <>
                  <svg className="animate-spin h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z" />
                  </svg>
                  {t.submitting}
                </>
              ) : (
                <>{t.submit}</>
              )}
            </button>

          </div>
        </form>
      </div>
    </div>
  );
};

export default VolunteerForm;